'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
    ErrorController

    ErrorController is a base mogo component that handles the creation and destruction
    of the ConnectionError mogo-page component. It implements the callbacks that are
    passed to the ConnectionError component. When a successful reconnection attempt is
    made, control is returned back to the caller through a callback, and the original
    mogo-page component is reinstated. The ErrorController also implements standard
    logic to determine if an error is a general connection error.
    If there is no backend data-action, a function that returns a promise can be used
    instead. The response of the promise will be used to determine whether to restore
    the original page.

    Methods (see methods for additional usage):
        invokeConnectionIssuePage(request, analytics, callback)

        isGeneralConnectionIssue(dataObj, responseStatus)
*/
function _ErrorController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_Routes];

  this._apiRequestCopy = null;
  this._dataActionNode = null;
  this._dataAction = null;
  this._dataActionCallbackId = null;
  this._apiRequestPending = false;
  this._dataActionPending = false;
  this._promisePending = null;
  this._pageComponent = null;
  this._parentNode = null;
  this._isEntirePage = true;
  this._retryRequest = false;
  this._errorType = null;
  this._issue = '';
  this._productAffected = '';
  this._tryAgainCallback = null;
  this._finalFailCallback = null;

  this.request = null;
  this.returnCallback = null;

  this.init = function () {};

  this.initAllReady = function () {};

  /*
        Description:
            Invoke the connection issue page. Loads the content for the connection
            issue page, and creates the mogo-ui-page component.
         Arguments:
            request (required) [APIRequest | HTMLElement | Object]:
                The request to be continuously re-attempted by this component. The request
                must be either a APIRequest object, a node with a data-action attribute,
                an object with the key of 'action' and value of a valid action
                (specified as model.action), and optional key of 'data' with a data object,
                or an object with the key of 'promise' that is a function that returns
                a jquery Deferred object,
                eg. {action: [String], data: [object] (optional)}
                eg. {promise: [function]}
             analytics [object] (optional):
                An object containing  metadata required for analytics. The object
                should contain a productLabel property specifying the product.
                eg. {productLabel: "<MogoMember | MogoCard | Money>"}
             callback [function] (optional):
                The callback function to return control back to original page. This
                is optional, as there may already be a callback to the original
                page through the callback on the APIRequest or data-action.
             config [object] (optional):
                An object containing config options for the presentation of the connection
                issue page. This includes the node to hide and the view to show during the
                connection issue.
                eg. {node: [HTMLElement], view: [String], isEntirePage: [boolean]}
         Returns:
            [boolean]
                true if successful, false otherwise.
     */
  this.invokeConnectionIssuePage = function (request, analytics, callback, config) {
    // Connection issue page already exists
    if ($('.connection-error').length > 0) {
      return false;
    }

    // Setup config
    var view = '/member/connection-error';
    var invocationCallback = null;
    if (config) {
      if (config.view != null) view = config.view;
      if (config.node != null) this._parentNode = config.node;
      if (config.isEntirePage != null) this._isEntirePage = config.isEntirePage;
      if (config.retryRequest != null) this._retryRequest = config.retryRequest;
      if (config.invocationCallback != null) invocationCallback = config.invocationCallback;
      if (config.tryAgainCallback != null) this._tryAgainCallback = config.tryAgainCallback;
      if (config.finalFailCallback != null) this._finalFailCallback = config.finalFailCallback;
    }

    this.request = request, this.returnCallback = callback;
    // Check if request is a valid request parameter
    if (this.request == null || !(this.request instanceof APIRequest || this.request instanceof HTMLElement && $(this.request).data('action') != null || _typeof(this.request) === 'object' && this.presenter.hasAction(this.request.action) || _typeof(this.request) === 'object' && typeof this.request.promise === 'function')) {
      throw new Error('request parameter is invalid');
      return false;
    }
    if (this.request instanceof APIRequest) {
      // APIRequest object
      if (this._retryRequest) {
        // Wrap original callback with _onRequestCallback
        request.callback = function (originalCallback, data, response, request) {
          this._onRequestCallback(data, response);
          if (arguments.length > 1) {
            var args = [];
            for (var i = 1; i < arguments.length; i++) {
              args.push(arguments[i]);
            }
            originalCallback.apply(null, args);
          } else {
            originalCallback();
          }
        }.bind(this, request.callback);
      } else {
        this._apiRequestCopy = new APIRequest(this.request._url, this.request._type, this.request._data, this._onRequestCallback.bind(this), this.request.pollingInterval);
      }
    } else if (_typeof(this.request) === 'object' && this.presenter.hasAction(this.request.action)) {
      // Object with action, parameter keys
      this._dataAction = this.request.action;
      this._dataActionCallbackId = this.presenter.addCallbackToAction(this._dataAction, this._onDataActionCallback.bind(this));
    } else if (_typeof(this.request) === 'object' && typeof this.request.promise === 'function') {} else if (this.request instanceof HTMLElement && $(this.request).data('action') != null) {
      // HTML Node with data-action attribute
      this._dataActionNode = $(this.request)[0];
      this._dataAction = $(this.request).data('action');
      this._dataActionCallbackId = this.presenter.addCallbackToAction(this._dataAction, this._onDataActionCallback.bind(this));
    }

    var productAffected = analytics.productLabel || '';
    var errorType = analytics.errorType || this._errorType;

    if (analytics) {
      if (analytics.errorType) {
        this._errorType = analytics.errorType;
      }
      if (analytics.productLabel) {
        this._productAffected = analytics.productLabel;
      }
    }

    var loadConnectionIssueContentCallback = this._loadConnectionIssueContent.bind(this, request, true, {
      Issue: [this._errorType + ' Try Again'],
      ProductAffected: [this._productAffected]
    });
    var params = {
      url: view,
      type: 'GET',
      headers: {
        'Content-Type': 'text/html'
      },
      dataType: 'html',
      complete: loadConnectionIssueContentCallback
    };
    $.ajax(params);

    // Analytics
    this._issue = this._errorType ? this._errorType + ' Connection' : 'Unknown Connection';

    // invocationCallback
    if (invocationCallback) invocationCallback();

    return true;
  };

  /*
        Description:
            Checks if the issue is a generic connection issue that should be handled
            by the ErrorController. Analyzes data and response status returned by
            the API service. Also sends an event to analytics.
         Arguments:
            dataObj [object] (required):
                The data object returned by the response.
             responseStatus [integer] (required):
                The response status (HTTP code) returned by the response.
         Returns:
            [boolean]
                true if successful, false otherwise.
     */
  this.isGeneralConnectionIssue = function (dataObj, responseStatus) {
    if (responseStatus === 500 && (dataObj.errors[0].key === 'error_allow_retry' || dataObj.errors[0].key === 'loan_service_trust_science_timeout_error')) {
      this._errorType = '3rd Party';
      return true;
    }
    if (responseStatus == 200 || responseStatus == 202 || responseStatus == 500) {
      return false;
    }
    if (responseStatus == 503) {
      // Account services offline - forward to maintenance page
      location.replace(this.paths.maintenance);
    }
    if (('' + responseStatus).indexOf('5') == 0) {
      if (dataObj && dataObj.errors && (dataObj.errors[0].property == 'fis' || dataObj.errors[0].property == 'netbanx' || dataObj.errors[0].property == 'crypto_exchange')) {
        this._errorType = '3rd Party';
      } else {
        this._errorType = 'SOA';
      }
      return true;
    }
    if (responseStatus == 400) {
      if (dataObj && dataObj.errors && (dataObj.errors[0].property == 'fis' || dataObj.errors[0].property == 'netbanx')) {
        this._errorType = '3rd Party';
        return true;
      }
      return false;
    }
    if (responseStatus == 408) {
      this._errorType = 'SOA';
      return true;
    }
    if (responseStatus == 0) {
      this._errorType = 'SOA';
      return true;
    }
    if (dataObj == null && responseStatus == null) {
      this._errorType = 'SOA';
      return true;
    }
    return false;
  };

  this.retryRequest = function (seconds) {
    if (seconds <= 0 && this._pageComponent) {
      // at the end
      if (this._apiRequestPending || this._dataActionPending || this._promisePending) {
        this._pageComponent.showOvertimeState();
      } else {
        this._pageComponent.showFinalState();
        if (this.request instanceof APIRequest) {
          if (this._retryRequest) {
            this.request.cancel(); // reset the state of APIRequest
          } else {
            this._apiRequestCopy.cancel(); // reset the state of APIRequest
          }
        }
      }
    } else if (seconds > 0 && seconds % 10 === 0) {
      // retry only every 10 seconds
      // Redundant hide current page
      this._hideCurrentPage();

      // Retrieve request
      if (this.request instanceof APIRequest && !this._apiRequestPending) {
        // APIRequest
        if (this._retryRequest) {
          this.request.retry();
        } else {
          this._apiRequestCopy.send();
        }
        this._apiRequestPending = true;
      } else if (this.request instanceof HTMLElement && $(this.request).data('action') != null && !this._dataActionPending) {
        // data-action node
        $(this._dataActionNode).submit();
        this._dataActionPending = true;
        // Object with action, parameter keys
      } else if (_typeof(this.request) === 'object' && this.presenter.hasAction(this.request.action) && !this._dataActionPending) {
        this.presenter.performAction(this._dataAction, this.request.data);
        this._dataActionPending = true;
      } else if (_typeof(this.request) === 'object' && typeof this.request.promise === 'function' && !this._promisePending) {
        this._promisePending = this.request.promise().always(this._onPromiseCallback.bind(this)).done(this._onPromiseSuccessCallback.bind(this));
      }
    }
  };

  this.restorePage = function () {
    if (this._pageComponent) {
      this._pageComponent.destroy();
    }
    if (this._isEntirePage) {
      var pageComponents = $('[data-mogo-page]', this._parentNode);
      for (var i = 0; i < pageComponents.length; i++) {
        $(pageComponents[i]).show();
      }
    } else {
      $(this._parentNode).show();
    }
  };

  this.destroyCallbackFromAction = function () {
    if (this._dataActionCallbackId) {
      this._dataActionCallbackId = this.presenter.removeCallbackFromAction(this._dataAction, this._dataActionCallbackId);
    }
  };

  this._loadConnectionIssueContent = function (request, allowTryAgain, analytics, response, status) {
    if (status != 'success') {
      console.error('error loading connection issue page');
      return;
    }

    if (response.status == 200) {
      if ($('#connection-error').length > 0) {
        return;
      }

      if (response.responseText) {
        var path = location.pathname;
        var html = $(response.responseText);

        if (path.substr(-1) === '/') {
          path = path.substr(0, path.length - 1);
        }

        if (!this._isEntirePage) {
          html.removeAttr('id');
          html.insertAfter(this._parentNode);
        } else if (this._routes[path].tray != null) {
          this._parentNode = $('.portal__tray')[0];
          html.appendTo(this._parentNode);
        } else if (this._routes[path].trayside != null) {
          this._parentNode = $('.portal__trayside')[0];
          html.appendTo(this._parentNode);
        } else if (this._routes[path].primary != null) {
          this._parentNode = $('.portal__primary')[0];
          html.appendTo(this._parentNode);

          // Modify CSS classes for viewArea connection error
          var flexer = $('.connection-error__flexer');
          var tryAgainButtonContainer = $('.connection-error__button--dashboard').parent();
          $(flexer).removeClass('medium-10 large-10 xlarge-9');
          $(flexer).addClass('medium-12 large-12 xlarge-12');
          $(tryAgainButtonContainer).attr('data-view', null);
          $(tryAgainButtonContainer).css('display', 'none');
          $('.connection-error__buttons .columns').addClass('small-centered');
        }
        var connectionErrorConfig = {
          destroyCallback: this.destroyCallbackFromAction.bind(this),
          allowTryAgain: allowTryAgain,
          analyticsData: analytics,
          isEntirePage: this._isEntirePage,
          retryCallback: this.retryRequest.bind(this),
          hidePage: this._hideCurrentPage.bind(this)
        };
        if (this._tryAgainCallback) {
          connectionErrorConfig.tryAgainCallback = this._tryAgainCallback;
        }
        if (this._finalFailCallback) {
          connectionErrorConfig.finalFailCallback = this._finalFailCallback;
        }
        this._pageComponent = html.mogo().create('ConnectionError', connectionErrorConfig, 'page');

        // Analytics
        this.analytics.pushEvent('connection-issue', {
          Issue: [this._issue],
          ProductAffected: [this._productAffected]
        });

        // Add analytics to Try Again and Dashboard button
        $('.connection-error__button--again').attr('data-analytics-id', this._productAffected + '-Error-' + this._errorType + ' Try Again-null-' + this._productAffected);
        $('.connection-error__button--dashboard').attr('data-analytics-id', 'data-analytics-id', this._productAffected + '-Error-' + this._errorType + this._productAffected + '-Error-' + this._errorType + ' Dashboard-null-' + this._productAffected);

        // scan for action-based dependencies
        this.presenter.scanDOM(this._pageComponent.node);

        // Hide current page
        this._hideCurrentPage();
      }
    } else {
      console.error('error loading connection issue page');
    }
  };

  this._onPromiseCallback = function () {
    this._promisePending = null;
    if (this._pageComponent) {
      this._pageComponent._apiRequestPending = false;
    }
  };

  this._onPromiseSuccessCallback = function () {
    this._pageComponent.cancelTimer();
    this.restorePage();
    if (typeof this.returnCallback === 'function') {
      this.returnCallback(dataObj, responseStatus);
    }
  };

  this._onRequestCallback = function (dataObj, responseStatus, request) {
    this._apiRequestPending = false;
    if (this._pageComponent) {
      this._pageComponent._apiRequestPending = false;
    }
    if (!this.isGeneralConnectionIssue(dataObj, responseStatus)) {
      this._pageComponent.cancelTimer();
      this.restorePage();
      if (!this._retryRequest) {
        this.request.callback(dataObj, responseStatus, this._apiRequestCopy);
      }

      if (typeof this.returnCallback === 'function') {
        this.returnCallback(dataObj, responseStatus, request);
      }
    }
  };

  this._onDataActionCallback = function (dataObj, responseStatus) {
    this._dataActionPending = false;
    if (this._pageComponent) {
      this._pageComponent._apiRequestPending = false;
    }
    if (!this.isGeneralConnectionIssue(dataObj, responseStatus)) {
      if (this._pageComponent) {
        this._pageComponent.cancelTimer();
      }
      this.restorePage();
      this.destroyCallbackFromAction();
      if (typeof this.returnCallback === 'function') {
        this.returnCallback(dataObj, responseStatus);
      }
    }
  };

  this._hideCurrentPage = function () {
    // Hide current page
    if (this._parentNode) {
      if (this._isEntirePage) {
        var pageComponents = $('[data-mogo-page]', this._parentNode);
        for (var i = 0; i < pageComponents.length; i++) {
          if ($(pageComponents[i]).mogo().declaredClass != 'ConnectionError') {
            $(pageComponents[i]).css('display', 'none');
          }
        }
      } else {
        $(this._parentNode).hide();
      }
    }
  };
}